export default __webpack_public_path__ + "assets/images/image-blind-bags.3aa26ace.png";